"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getLowProductAvailability = function getLowProductAvailability(availabilityLevel) {
  var outOfStockCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return outOfStockCheck ? availabilityLevel === global.__appConfig__.outOfStockProductAvailability : availabilityLevel === global.__appConfig__.lowProductAvailability;
};
var _default = getLowProductAvailability;
exports["default"] = _default;